export default __webpack_public_path__ + "5a2b694626dafdcb5b906d889ac6f3ba72dc056f800c0ae96ce4340cf4814887.svg";